import Duck from 'extensible-duck';
import { createSelector } from 'reselect';

var selectors = function selectors() {
  return {
    iframely: new Duck.Selector(function () {
      return function (state) {
        return state === null || state === void 0 ? void 0 : state.iframely;
      };
    }),
    getUrls: new Duck.Selector(function (selectors) {
      return createSelector(selectors.iframely, function (_temp) {
        var _ref = _temp === void 0 ? {} : _temp,
          url_data = _ref.url_data;
        return url_data;
      });
    }),
    getCurrentUrl: new Duck.Selector(function (selectors) {
      return createSelector(selectors.iframely, function (_temp2) {
        var _ref2 = _temp2 === void 0 ? {} : _temp2,
          current_url = _ref2.current_url;
        return current_url;
      });
    }),
    getLoadingStatus: new Duck.Selector(function (selectors) {
      return createSelector(selectors.iframely, function (_temp3) {
        var _ref3 = _temp3 === void 0 ? {} : _temp3,
          loading = _ref3.loading;
        return loading;
      });
    }),
    getLinkDataByUrl: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getUrls, function (_, linkUrl) {
        return linkUrl;
      }, function (url_data, linkUrl) {
        return (url_data === null || url_data === void 0 ? void 0 : url_data[linkUrl]) || null;
      });
    }),
    getRichMediaByUrl: new Duck.Selector(function (selectors) {
      return createSelector(function (state, linkUrl) {
        return selectors.getLinkDataByUrl(state, linkUrl);
      }, function (linkData) {
        return ['photo', 'video', 'rich'].includes(linkData === null || linkData === void 0 ? void 0 : linkData.type) ? linkData : null;
      });
    }),
    getAllRichMedia: new Duck.Selector(function (selectors) {
      return createSelector(selectors.getUrls, function (url_data) {
        return Object.entries(url_data).reduce(function (acc, _ref4) {
          var url = _ref4[0],
            data = _ref4[1];
          if (['photo', 'video', 'rich'].includes(data === null || data === void 0 ? void 0 : data.type)) {
            var _Object$assign;
            return Object.assign({}, acc, (_Object$assign = {}, _Object$assign[url] = data, _Object$assign));
          }
          return acc;
        }, {});
      });
    })
  };
};

export { selectors as default };
//# sourceMappingURL=selectors.js.map
